import { render, staticRenderFns } from "./SmsHistoryList.vue?vue&type=template&id=63eff6c0&scoped=true&"
import script from "./SmsHistoryList.vue?vue&type=script&lang=js&"
export * from "./SmsHistoryList.vue?vue&type=script&lang=js&"
import style0 from "./SmsHistoryList.vue?vue&type=style&index=0&id=63eff6c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63eff6c0",
  null
  
)

export default component.exports